import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './assets/styles/app.scss';
import liff from '@line/liff/dist/lib';
import { LIFF_ID } from './lib';

liff
  .init({
    liffId: LIFF_ID,
    withLoginOnExternalBrowser: true
  })
  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('root')
    );
  })
  .catch((e) => {
    console.log(`LIFF error: ${e.message}`);
    localStorage.clear();
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
